import React from "react";

const LiftUpContainer = (props) => {
  const { children, isActive, setisActive } = props;
  return (
    <div className={`lift-up-container ${isActive ? "lift-up-active" : ""}`}>
      <div className="bg-dark" onClick={() => setisActive(false)} />
      <div className="lift-up-content">{children}</div>
    </div>
  );
};

export default LiftUpContainer;
